module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_7.44e1f271.png";